import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Subscription } from 'rxjs';

import { TableConfig, TableConfigUtils } from '@app/shared/util/table-config.utils';

import { Ticket } from '@models/ticket.model';

import { TicketService } from '@services/ticket.service';
import { NotificationService } from '@services/notification.service';

import { Log } from 'ng2-logger';
import { AppUtils } from '@app/shared/util/app.utils';
import { AuthenticationService } from '@app/authentication/services/authentication.service';
import {
    ServiceTicketsTableComponent
} from "@app/roles/service-operator/pages/service-tickets/components/service-tickets-table/service-tickets-table.component";

@Component({
    selector: 'app-service-tickets',
    templateUrl: './service-tickets.component.html',
    styleUrls: ['./service-tickets.component.scss']
})
export class ServiceTicketsComponent implements OnInit, OnDestroy {

    @ViewChild(ServiceTicketsTableComponent, {static: false}) ticketTable: ServiceTicketsTableComponent;

    _logger = Log.create(ServiceTicketsComponent.name);

    tickets: Ticket[] = [];
    tableConfig = new TableConfig();
    isLoading = false;

    newServiceTicketsSubscription: Subscription;
    selectedPlantsChangedSubscription: Subscription;
    receivedPlantsSubscription: Subscription;
    routeSubscription: Subscription;
    newUpdatedTickets: Subscription;

    type: string;
    facilityId: number;

    allExpanded = true;
    hasFilters = true;


    constructor(private ticketService: TicketService,
                private router: Router,
                private notificationService: NotificationService,
                private route: ActivatedRoute,
                private authService: AuthenticationService) {

        this.selectedPlantsChangedSubscription = this.notificationService.selectedPlantsChangedAsObservable.subscribe(data => {
            this.getServiceTickets(this.tableConfig);
        });

        this.newServiceTicketsSubscription = this.notificationService.serviceOperatorQueueAsObservable.subscribe(
            (data) => {
                this._logger.info('serviceOperatorQueue:: Socket refreshed service tickets, retrieved data', data);
                this.getServiceTickets(this.tableConfig);
            }
        );

        this.newUpdatedTickets = this.notificationService.updatedNewTicketQueueAsObservable.subscribe((value) => {
            this.getServiceTickets(this.tableConfig);
        });
    }

    ngOnInit() {
        const currentUser = this.authService.getUserDetails();
        this.routeSubscription = this.route.queryParams.subscribe(
            (params) => {
                this.type = params['type'];
                this.facilityId = params['facilityId'];
                this.tableConfig = new TableConfig();
                if (AppUtils.corePlantsLoaded(currentUser)) {
                    this.getServiceTickets(this.tableConfig);
                } else {
                    this.receivedPlantsSubscription = this.notificationService.selectedPlantsReceivedFromAPIAsObservable.subscribe(() => {
                        this.getServiceTickets(this.tableConfig);
                    });
                }
            }
        );
    }

    getServiceTickets(tableConfig) {
        this._logger.info('getServiceTickets:: Retrieving service tickets');
        this.isLoading = true;
        tableConfig = AppUtils.appendPlantsQuery(tableConfig);
        this.ticketService.getAllTickets(tableConfig, this.facilityId).subscribe(
            (data) => {
                this._logger.info('getServiceTickets:: API Returned data', data);
                this.tickets = TableConfigUtils.addColorToTicketByPriority(data.tickets);
                this.tableConfig.pager.count = data.count;
                this.tableConfig.pager.page = tableConfig.pager.page;
                this.isLoading = false;
            },
            (error) => {
                this._logger.error('getServiceTickets:: API Returned error', error);
                this.isLoading = false;
            }
        )
    }

    onSortChange(tableState) {
        this.getServiceTickets(tableState);
    }

    onFilter(tableConfig: TableConfig) {
        this.getServiceTickets(tableConfig);
    }

    onTableRowClick(ticket: Ticket) {
        this.router.navigate([ticket.id + '/details'], {
            queryParams: {type: this.type, facilityId: this.facilityId},
            relativeTo: this.route
        });
    }

    onPageChange(tableConfig: TableConfig) {
        this._logger.info("onPageChange:: ", tableConfig);
        this.getServiceTickets(tableConfig);
    }

    ngOnDestroy() {
        if (this.newServiceTicketsSubscription) {
            this.newServiceTicketsSubscription.unsubscribe();
        }

        if (this.selectedPlantsChangedSubscription) {
            this.selectedPlantsChangedSubscription.unsubscribe();
        }

        if (this.receivedPlantsSubscription) {
            this.receivedPlantsSubscription.unsubscribe();
        }

        if (this.routeSubscription) {
            this.routeSubscription.unsubscribe();
        }

        if (this.newUpdatedTickets) {
            this.newUpdatedTickets.unsubscribe();
        }
    }

    toggleExpanded() {
        this.allExpanded = !this.allExpanded;
        if (this.ticketTable) {
            this.ticketTable.toggleExpand(this.allExpanded);
        }
    }

    toggleFilters() {
        this.hasFilters = !this.hasFilters;
    }
}
